<div [ngClass]="customCssClass !== '' ? 'card ' + customCssClass : 'card '">
  <ng-content></ng-content>
</div>
